/**
 * Created by piotr.pozniak@thebeaverhead.com on 02/10/2024
 */

import React, { useCallback, useEffect, useState } from "react";
import ClipboardCopyInput from "../ClipboardCopyInput";
import RadioInput from "./RadioInput";
import useDidMountEffect from "../../../../hooks/useDidMountEffect";

const ShareableUrl = ({
  url,
  widgetModel,
  widgetTypeName,
  onUpdateSettings,
  onSubmit,
}) => {
  const hasRedirection = widgetModel?.widget_settings?.hasRedirection || false;
  const redirectionUrl = widgetModel?.widget_settings?.redirectionUrl || "";

  useDidMountEffect(() => {
    onSubmit();
  }, [hasRedirection]);

  /**
   *
   * @type {(function(*))|*}
   */
  const onToggleUrlRedirection = useCallback(
    (fieldName) => (e) => {
      onUpdateSettings("hasRedirection", !hasRedirection);
    },
    [onUpdateSettings, hasRedirection]
  );

  /**
   *
   * @type {(function(*))|*}
   */
  const onChangeRedirectUrl = useCallback(
    (e) => {
      onUpdateSettings("redirectionUrl", e.target.value);
    },
    [onUpdateSettings]
  );

  const onSubmitRedirectUrl = useCallback(
    (e) => {
      e.preventDefault();
      onSubmit();
    },
    [onSubmit]
  );

  const redirectionBlock = hasRedirection ? (
    <div className={"input-group"}>
      <input
        id={"url-redirect"}
        type="text"
        className="form-control form-control-sm"
        placeholder={"Webpage URL address"}
        value={redirectionUrl}
        onChange={onChangeRedirectUrl}
      />
      <div className={"input-group-append"}>
        <button className={"btn btn-primary"} onClick={onSubmitRedirectUrl}>
          Save
        </button>
      </div>
    </div>
  ) : null;

  return (
    <form action="#" className={"m-t-15"}>
      <h5>Sharable URL</h5>
      <div className="form-group ">
        <div className="col-xs-12">
          <ClipboardCopyInput
            id={"shareable_url"}
            value={url}
            placeholder={`${widgetTypeName} Shareable URL`}
          />
          <div className={"alert alert-info"}>
            <div className={"d-flex align-items-start"}>
              <i className={"material-icons icon-sm text-info p-0 m-0 m-r-5"}>
                info
              </i>
              <small>
                Copy the Link above to easily share it via email, social, mobile
                app or or any instant messaging app.
              </small>
            </div>
          </div>
        </div>
      </div>
      <h5>
        Link Redirection <div className={"badge badge-tertiary"}>BETA</div>
      </h5>
      <div className="col-xs-12">
        <div className="form-group ">
          <RadioInput
            fieldName={"hasRedirection"}
            label={"Enable URL redirection"}
            onChange={onToggleUrlRedirection}
            checked={hasRedirection}
            disabled={false}
            className={"mb-0"}
            variant={"warning"}
          />
          <div className={"alert alert-info"}>
            <div className={"d-flex align-items-start"}>
              <i className={"material-icons icon-sm text-info p-0 m-0 m-r-5"}>
                info
              </i>
              <small>
                Redirect users to the website where your widget is embedded,
                enhancing your site's page views and engagement.
              </small>
            </div>
          </div>
          {redirectionBlock}
        </div>
      </div>
    </form>
  );
};

export default ShareableUrl;
